import React from 'react';
import { Button, Dropdown } from 'antd';
import { SunOutlined, MoonOutlined } from '@ant-design/icons';
import { useTheme } from '../contexts/ThemeContext';
import { useTranslation } from 'react-i18next';

const ThemeModeSwitcher = ({ buttonClassName = '' }) => {
  const { themeMode, setTheme } = useTheme();
  const { t } = useTranslation();

  const handleThemeModeChange = ({ key }) => {
    setTheme(key);
  };

  const menuItems = [
    {
      key: 'light',
      label: t('common.lightTheme', 'Light'),
      icon: <SunOutlined />,
    },
    {
      key: 'dark',
      label: t('common.darkTheme', 'Dark'),
      icon: <MoonOutlined />,
    },
  ];

  return (
    <Dropdown
      menu={{
        items: menuItems,
        onClick: handleThemeModeChange,
        selectedKeys: [themeMode],
      }}
      placement="bottomRight"
      getPopupContainer={() => document.body}
      overlayStyle={{ zIndex: 1200 }}
    >
      <Button
        type="text"
        className={buttonClassName}
        icon={themeMode === 'dark' ? <MoonOutlined /> : <SunOutlined />}
        title={themeMode === 'dark' ? t('common.darkTheme', 'Dark') : t('common.lightTheme', 'Light')}
      />
    </Dropdown>
  );
};

export default ThemeModeSwitcher;
